<div class="container-fluid email-wrap bookmark-wrap todo-wrap">
    <div class="row">
        <app-list></app-list>
<!--        <div class="col-xl-3 xl-30 box-col-12">-->
<!--            <div class="email-sidebar md-sidebar" (clickOutside)="outSideClose()">-->
<!--                <a class="btn btn-primary email-aside-toggle md-sidebar-toggle" (click)="isOpenToDo= !isOpenToDo">Filtro de tareas</a>-->
<!--                <div class="email-left-aside md-sidebar-aside custom-scrollbar todo-list-sidebar" [class.open]="isOpenToDo">-->
<!--                    <div class="card">-->
<!--                        <div class="card-body">-->
<!--                            <div class="email-app-sidebar left-bookmark custom-scrollbar">-->
<!--                                <ul class="nav main-menu">-->
<!--                                    <li class="nav-item">-->
<!--                                        <button class="btn-primary txt-light d-block btn-mail w-100" (click)="newTask()">-->
<!--                                            <app-feather-icons [class]="'me-2'" [icons]="'plus-circle'"></app-feather-icons>Nueva tarea-->
<!--                                        </button>-->
<!--                                    </li>-->

<!--                                    <li class="nav-item">-->
<!--                                        <a href="javascript:void(0)" class="py-2">-->
<!--                                          <span class="iconbg badge-light-primary">-->
<!--                                            <app-feather-icons [icons]="'list'"></app-feather-icons>-->
<!--                                          </span>-->
<!--                                            <span class="title ms-2">Todo</span>-->
<!--                                        </a>-->
<!--                                    </li>-->

<!--                                    <li class="nav-item">-->
<!--                                        <a href="javascript:void(0)" class="py-2">-->
<!--                                          <span class="iconbg badge-light-success">-->
<!--                                            <app-feather-icons [icons]="'check'"></app-feather-icons>-->
<!--                                          </span>-->
<!--                                            <span class="title ms-2">Abiertos</span>-->
<!--                                        </a>-->
<!--                                    </li>-->

<!--                                    <li class="nav-item">-->
<!--                                        <a href="javascript:void(0)" class="py-2">-->
<!--                                          <span class="iconbg badge-light-success">-->
<!--                                            <app-feather-icons [icons]="'check'"></app-feather-icons>-->
<!--                                          </span>-->
<!--                                            <span class="title ms-2">En Proceso</span>-->
<!--                                        </a>-->
<!--                                    </li>-->

<!--                                    <li class="nav-item">-->
<!--                                        <a href="javascript:void(0)" class="py-2">-->
<!--                                          <span class="iconbg badge-light-danger">-->
<!--                                            <app-feather-icons [icons]="'alert-circle'"></app-feather-icons>-->
<!--                                          </span>-->
<!--                                            <span class="title ms-2">Atrasados</span>-->
<!--                                        </a>-->
<!--                                    </li>-->

<!--                                    <li class="nav-item">-->
<!--                                        <a href="javascript:void(0)" class="py-2">-->
<!--                                          <span class="iconbg badge-light-info">-->
<!--                                            <app-feather-icons [icons]="'check-circle'"></app-feather-icons>-->
<!--                                          </span>-->
<!--                                            <span class="title ms-2">Finalizados</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                </ul>-->

<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-xl-9 xl-70 box-col-12">-->
<!--            <app-list></app-list>-->
<!--        </div>-->
    </div>
</div>
